import { useEffect, useState } from 'react';
import { laboratoryClient } from '../utils/laboratory';
import { TACQ0004_EXPERIMENT_KEY } from '../constants/laboratory';
const useLaboratoryTreatments = () => {
  var _treatments$TACQ0004_;
  const [treatments, setTreatments] = useState();
  useEffect(() => {
    laboratoryClient.resolve(treatmentsResult => {
      setTreatments(treatmentsResult);
    });
  }, []);
  return {
    treatments: treatments || {},
    isLoading: !!treatments,
    isInTACQ0004VariationGroup: (treatments === null || treatments === void 0 || (_treatments$TACQ0004_ = treatments[TACQ0004_EXPERIMENT_KEY]) === null || _treatments$TACQ0004_ === void 0 || (_treatments$TACQ0004_ = _treatments$TACQ0004_.parameters) === null || _treatments$TACQ0004_ === void 0 ? void 0 : _treatments$TACQ0004_.group) === 'variation'
  };
};
export default useLaboratoryTreatments;